
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Hinjewaditomumbaicabservice() {



    const cardData =
    {
        keyword: 'Hinjewadi to Mumbai Cab Service',
        heading: 'Meghana Cab : Hinjewadi to Mumbai Cab Service',
        headingDescription: 'Meghana Cab offers Hinjewadi to Mumbai Cab Service, ideal for IT professionals, business travelers, and families seeking reliable transportation from Pune’s major tech hub to Mumbai. Our fleet includes well-maintained Sedans, SUVs, Innova Crysta, and Tempo Travellers, ensuring comfort and safety for every journey. Whether you need a cab for airport transfer, business meetings, or a weekend getaway, we provide on-time pickups, courteous drivers, and competitive pricing. Book your Hinjewadi to Mumbai Cab with Meghana Cab and enjoy a smooth, stress-free ride with 24/7 customer support and door-to-door convenience.',


        top: 'Top Places to Visit in Mumbai with Meghana Cab',

      "topPlaces": [
   
  {
    "title": "Marine Drive & Girgaon Chowpatty",
    "description": "Stretching 3.6 kilometers along the Arabian Sea, Marine Drive is Mumbai’s iconic palm-lined promenade shaped like a necklace, earning it the nickname 'Queen’s Necklace.' It’s a favorite spot for joggers, lovers, and tourists who gather to admire the sea view and city skyline, especially at sunset. At the northern end lies Girgaon Chowpatty, a lively beach known for its street food—bhel puri, pav bhaji, gola—and as a venue for the grand Ganesh Visarjan immersions. The entire stretch embodies Mumbai’s coastal spirit and urban pulse."
  },
   {
    "title": "Elephanta Caves",
    "description": "Located 11 km offshore on Elephanta Island, these 5th-to-8th-century rock-cut caves are a UNESCO World Heritage Site showcasing ancient Indian art dedicated primarily to Lord Shiva. The highlight is the massive Trimurti sculpture—depicting the three aspects of Shiva—carved into a single rock face. The island offers not just religious and artistic significance but also scenic views, lush trails, and a tranquil ferry ride from the Gateway of India, making it a full-day cultural and nature getaway from Mumbai's bustle."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
    "description": "A masterpiece of Victorian Gothic Revival architecture fused with Indian design, CST (formerly Victoria Terminus) is a UNESCO World Heritage Site and one of India’s busiest railway stations. Constructed in 1887, the terminus features turrets, pointed arches, domes, stained-glass windows, and intricate carvings of animals and deities. It stands as a testament to colonial-era craftsmanship while functioning as a modern-day transport lifeline for over 3 million daily commuters. Its majestic façade is especially breathtaking when illuminated at night."
  },
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most enduring symbol, built in 1924 to commemorate the visit of King George V and Queen Mary. Overlooking the Arabian Sea, this colossal basalt arch marks the point from which the last British troops left India, making it both a historical and emotional landmark. Located in Apollo Bunder, it serves as a hub for ferry rides to Elephanta Island and provides stunning views at sunrise and sunset. The Indo-Saracenic style architecture and its vibrant surroundings filled with street vendors, photographers, and tourists make it a dynamic cultural hub."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "One of the richest and most visited temples in Mumbai, Siddhivinayak is dedicated to Lord Ganesha, the remover of obstacles. Originally built in 1801, it features a gold-plated inner sanctum and a unique idol carved from a single black stone, with the trunk curving to the right. The temple draws politicians, Bollywood celebrities, and millions of devotees annually, especially on Tuesdays when the lines stretch for hours. Despite the crowds, the spiritual atmosphere and meticulous organization make it a peaceful yet powerful experience."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Built in 1431 in honor of the Sufi saint Haji Ali, this Indo-Islamic marble dargah sits on a tiny islet 500 meters off the coast, connected by a narrow causeway that floods during high tide. It is visited by people of all religions and backgrounds, symbolizing Mumbai’s spiritual inclusiveness. With white domes, intricate mirror work, and prayers echoing against sea winds, it offers both a religious and atmospheric experience. The view of the Mumbai skyline from the dargah adds a contemplative beauty to the site."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Vastu Sangrahalaya (Prince of Wales Museum)",
    "description": "Housed in a grand Indo-Saracenic building amidst lush gardens, this museum features over 50,000 artifacts from ancient to modern India. Its galleries cover art, archaeology, armory, numismatics, and decorative arts, including standout collections of miniature paintings, Buddhist sculptures, Mughal weaponry, and European antiques. The museum offers guided tours, audio guides, and children's workshops, making it both educational and engaging for visitors of all ages. Its architectural grandeur and curated exhibits make it one of India’s finest museums."
  },
  {
    "title": "Colaba Causeway",
    "description": "A vibrant shopping and cultural district near the Gateway of India, Colaba Causeway offers a sensory overload of colors, sounds, and flavors. Street stalls sell everything from junk jewelry and antiques to clothing and souvenirs, while iconic cafés like Leopold and Café Mondegar cater to tourists and locals alike. It’s the perfect place to experience Mumbai’s cosmopolitan vibe, blending colonial architecture with contemporary fashion, street food, and bustling life from early morning until late night."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most popular coastal stretches, offering a blend of natural beauty, local flavors, and a touch of celebrity culture. Frequented by locals for evening walks, kite flying, and beachside yoga, the beach is also known for its chaat stalls, pony rides, and occasional film shoots. It's common to spot Bollywood stars residing nearby. The beach also hosts cultural festivals and public events, making it more than just a leisure destination—it’s a slice of Mumbai’s identity."
  },
  {
    "title": "Sanjay Gandhi National Park & Kanheri Caves",
    "description": "This 87-square-kilometer green oasis within city limits offers a rare mix of wildlife sanctuary, recreational space, and ancient history. The park houses deer, leopards, monkeys, and over 250 species of birds, along with a toy train, boating lake, and nature trails. The Kanheri Caves within the park—dating from 1st century BCE to 10th century CE—are a group of over 100 Buddhist rock-cut monasteries and prayer halls. The combination of spirituality, wildlife, and open space makes it one of Mumbai’s most unique destinations."
  }
],

"services": [
    {
        "name": "Hinjewadi to Mumbai One Way Cab",
        "description": "Book a convenient and reliable one way cab from Hinjewadi to Mumbai. Perfect for airport transfers, business trips, or family visits, our service ensures timely pickups, comfortable rides, and competitive fares tailored to your travel needs."
    },
    {
        "name": "Online Booking Cab Hinjewadi to Mumbai",
        "description": "Reserve your Hinjewadi to Mumbai cab quickly and securely through our online booking platform. Enjoy instant confirmation, transparent pricing, and a wide selection of vehicles to match your preferences and budget."
    },
    {
        "name": "Round Trip Taxi Hinjewadi to Mumbai",
        "description": "Plan your round trip between Hinjewadi and Mumbai with ease. Our round trip taxi service offers flexible scheduling, waiting options, and cost-effective pricing, making it ideal for business commuters and tourists alike."
    },
    {
        "name": "AC Car Hire Hinjewadi to Mumbai",
        "description": "Travel comfortably with our air-conditioned car hire service from Hinjewadi to Mumbai. Beat the heat and enjoy smooth rides with climate-controlled vehicles, perfect for long journeys or hot weather conditions."
    },
    {
        "name": "Sedan & SUV Cabs Hinjewadi to Mumbai",
        "description": "Choose from a range of sedan and SUV cabs for your trip from Hinjewadi to Mumbai. Sedans offer a stylish and efficient ride for small groups, while SUVs provide extra space and comfort for families and larger groups."
    },
    {
        "name": "Affordable Taxi Hinjewadi to Mumbai",
        "description": "Looking for budget-friendly travel options? Our affordable taxi service from Hinjewadi to Mumbai ensures you get reliable, clean vehicles at competitive rates without compromising on quality or comfort."
    },
    {
        "name": "Corporate Cab Hinjewadi to Mumbai",
        "description": "Efficiently manage your corporate travel with our professional Hinjewadi to Mumbai cab services. We offer timely pickups, professional chauffeurs, and billing options suitable for company employees and business executives."
    },
    {
        "name": "Chauffeur Driven Cab Hinjewadi to Mumbai",
        "description": "Experience luxury and convenience with our chauffeur-driven cabs from Hinjewadi to Mumbai. Our skilled drivers provide safe, courteous, and stress-free rides tailored for executives, VIPs, and discerning travelers."
    },
    {
        "name": "Long Distance Cab Hinjewadi to Mumbai",
        "description": "For long distance travel between Hinjewadi and Mumbai, our cab services offer comfort, safety, and reliability. Ideal for day trips, weekend getaways, or business travel, with vehicles maintained to the highest standards."
    },
    {
        "name": "24/7 Cab Service Hinjewadi to Mumbai",
        "description": "Our round-the-clock cab service ensures you can travel from Hinjewadi to Mumbai any time of day or night. Whether it’s an early morning flight or a late arrival, we’re ready to serve with punctuality and professionalism."
    },
    {
        "name": "Quick Cab Booking Hinjewadi to Mumbai",
        "description": "Need a cab fast? Use our quick booking option for Hinjewadi to Mumbai travel and get instant confirmation with no hassle. Perfect for last-minute plans, urgent business trips, or sudden travel needs."
    },
    {
        "name": "Private Car Hire Hinjewadi to Mumbai",
        "description": "Enjoy the privacy and convenience of a private car hire from Hinjewadi to Mumbai. Tailored for families, groups, or VIP travelers who prefer exclusive use of their vehicle with personalized service."
    },
    {
        "name": "Group Travel Cab Hinjewadi to Mumbai",
        "description": "Travel comfortably with your group from Hinjewadi to Mumbai. Our group travel cabs provide spacious vehicles and flexible seating arrangements, making them perfect for family outings, friends, or corporate teams."
    },
    {
        "name": "Budget Travel Cab Hinjewadi to Mumbai",
        "description": "Get the best value for your money with our budget travel cab service from Hinjewadi to Mumbai. Affordable rates, reliable vehicles, and friendly drivers combine to deliver an excellent travel experience."
    },
    {
        "name": "Fast Highway Taxi Hinjewadi to Mumbai",
        "description": "Take advantage of our fast highway taxi service for quick and smooth travel from Hinjewadi to Mumbai. Experienced drivers navigate the best routes for minimal travel time and maximum comfort."
    }
],
"tableData": [
    ["Hinjewadi to Mumbai One Way Cab", "Online Booking Cab Hinjewadi to Mumbai"],
    ["Round Trip Taxi Hinjewadi to Mumbai", "AC Car Hire Hinjewadi to Mumbai"],
    ["Sedan & SUV Cabs Hinjewadi to Mumbai", "Affordable Taxi Hinjewadi to Mumbai"],
    ["Corporate Cab Hinjewadi to Mumbai", "Chauffeur Driven Cab Hinjewadi to Mumbai"],
    ["Long Distance Cab Hinjewadi to Mumbai", "24/7 Cab Service Hinjewadi to Mumbai"],
    ["Quick Cab Booking Hinjewadi to Mumbai", "Private Car Hire Hinjewadi to Mumbai"],
    ["Group Travel Cab Hinjewadi to Mumbai", "Budget Travel Cab Hinjewadi to Mumbai"],
    ["Fast Highway Taxi Hinjewadi to Mumbai", ""]
],







"whychoose": [
    {
        "WhyChooseheading": "Reliable Hinjewadi to Mumbai Cab Service",
        "WhyChoosedescription": "Our Hinjewadi to Mumbai cab service offers punctual, safe, and comfortable rides tailored to your schedule. Whether for office commute, airport transfers, or leisure trips, we ensure timely pickups and smooth travel."
    },
    {
        "WhyChooseheading": "Wide Selection of Well-Maintained Vehicles",
        "WhyChoosedescription": "Choose from a fleet of clean, air-conditioned sedans, SUVs, and premium cars. Each vehicle undergoes regular maintenance and thorough cleaning to guarantee a comfortable and hygienic journey."
    },
    {
        "WhyChooseheading": "Professional and Experienced Drivers",
        "WhyChoosedescription": "Our drivers are trained, courteous, and familiar with the routes between Hinjewadi and Mumbai. They prioritize your safety and comfort, ensuring a smooth, hassle-free ride."
    },
    {
        "WhyChooseheading": "Transparent and Competitive Pricing",
        "WhyChoosedescription": "Enjoy affordable fares with no hidden charges. Our pricing includes tolls, taxes, driver allowances, and fuel, providing complete clarity and excellent value for your travel needs."
    },
    {
        "WhyChooseheading": "Flexible Booking and Customized Travel Options",
        "WhyChoosedescription": "Book one-way, round trips, or hourly rentals based on your convenience. Customize pickup and drop locations, travel timings, and route preferences to perfectly suit your itinerary."
    },
    {
        "WhyChooseheading": "Doorstep Pickup and Drop-off Service",
        "WhyChoosedescription": "Experience the convenience of door-to-door service. We pick you up from any location in Hinjewadi and drop you off at your desired destination in Mumbai, saving you time and effort."
    },
    {
        "WhyChooseheading": "Ideal for Corporate, Personal, and Airport Transfers",
        "WhyChoosedescription": "Whether you’re commuting for work, visiting friends, or catching a flight, our Hinjewadi to Mumbai cabs provide reliable, comfortable, and timely transportation."
    },
    {
        "WhyChooseheading": "24/7 Customer Support for a Hassle-Free Experience",
        "WhyChoosedescription": "Our dedicated customer support team is available around the clock to assist with bookings, cancellations, or any queries, ensuring a smooth and stress-free journey."
    }
]





















    }

const faqData = [
    {
        question: "How can I book a cab from Hinjewadi to Mumbai with Meghana Cab?",
        answer: "You can book your cab by calling us at +91 9075462128 or through our website for fast and secure booking."
    },
    {
        question: "What is the usual travel time from Hinjewadi to Mumbai by cab?",
        answer: "It typically takes around 3 to 4 hours to travel from Hinjewadi to Mumbai, depending on traffic conditions."
    },
    {
        question: "Are one way and round trip bookings available from Hinjewadi to Mumbai?",
        answer: "Yes, we provide both one way and round trip cab options for your convenience."
    },
    {
        question: "What types of cabs are available for the Hinjewadi to Mumbai route?",
        answer: "You can choose from hatchbacks, sedans, SUVs, and tempo travellers depending on your group size and preferences."
    },
    {
        question: "Is the cab service available 24/7 from Hinjewadi?",
        answer: "Yes, we operate round the clock, so you can book a cab anytime as per your schedule."
    },
    {
        question: "Does the fare include all charges like tolls and driver fee?",
        answer: "Yes, our fares are inclusive of fuel, tolls, and driver charges. Additional waiting or parking fees may be extra."
    },
    {
        question: "Can I book a cab at the last minute from Hinjewadi to Mumbai?",
        answer: "Yes, subject to availability, we accept last-minute bookings. For urgent needs, please call us directly."
    },
    {
        question: "Do you offer airport drop service from Hinjewadi to Mumbai International Airport?",
        answer: "Yes, we provide direct airport drop service from Hinjewadi to both Domestic and International terminals in Mumbai."
    },
    {
        question: "Is online booking secure and reliable?",
        answer: "Yes, our online booking system is safe and provides instant confirmation with secure payment gateways."
    },
    {
        question: "Can I request extra stops or breaks during the trip?",
        answer: "Yes, you can request additional stops. Please inform us in advance or during booking for better coordination."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Sagar Rane',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked a cab from Hinjewadi to Mumbai for an early morning flight. Service was prompt and stress-free.”',
    },
    {
        name: 'Ms. Meenal Patankar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very convenient and professional cab service from Hinjewadi to Mumbai. Will definitely book again.”',
    },
];




















































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Hinjewadi to Mumbai Cab Service",
  "image": "https://www.meghanacabs.com/assets/images/hinjewadi-to-mumbai-cab.jpg",
  "description": "Book a cab from Hinjewadi to Mumbai with Meghana Cabs. Choose from AC Sedans, SUVs, and chauffeur-driven cars. Affordable pricing for one-way and round trips, with 24/7 online booking and professional drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5213"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1899",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/hinjewadi-to-mumbai-cab-service"
  }
};








    return (
        <div>
<Helmet>
  <title>Hinjewadi to Mumbai Cab Service | Meghana Cabs</title>
  <meta 
    name="description" 
    content="Book a reliable cab from Hinjewadi to Mumbai with Meghana Cabs. Available 24/7 for one-way or round trips. Affordable fares, AC Sedans and SUVs, and chauffeur-driven vehicles for smooth travel." 
  />
  <meta 
    name="keywords" 
    content="Hinjewadi to Mumbai One Way Cab, Online Booking Cab Hinjewadi to Mumbai, Round Trip Taxi Hinjewadi to Mumbai, AC Car Hire Hinjewadi to Mumbai, Sedan & SUV Cabs Hinjewadi to Mumbai, Affordable Taxi Hinjewadi to Mumbai, Corporate Cab Hinjewadi to Mumbai, Chauffeur Driven Cab Hinjewadi to Mumbai, Long Distance Cab Hinjewadi to Mumbai, 24/7 Cab Service Hinjewadi to Mumbai, Quick Cab Booking Hinjewadi to Mumbai, Private Car Hire Hinjewadi to Mumbai, Group Travel Cab Hinjewadi to Mumbai, Budget Travel Cab Hinjewadi to Mumbai, Fast Highway Taxi Hinjewadi to Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/73.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Hinjewaditomumbaicabservice;